function BusyOverlay(props) {
  const {
  } = props;

  return (
    <div id="loader-wrapper-outside">
    <div className="lds-lring">
      <div className="lring" />
      <div className="lring" />
      <div className="lring" />
      <div className="lring" />
      <div className="lring" />
      <div className="lring" />

      <div className="logo">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 338.15 386">
          <defs>
          </defs>
          <g id="Layer_2" data-name="Layer 2">
            <g id="Logo_versions" data-name="Logo versions">
              <path
                className="cls-1"
                d="M169,9c5.67,0,18.23.1,23.91.26,45.15,1.29,89.57,7.85,133.39,18.68,3.1.77,2.82,2.6,2.82,4.77,0,61-.14,105.94.07,166.93.06,16.7-1.08,33.06-7,48.83-5.05,13.34-12.85,24.93-22.31,35.43C267.6,319.65,222.73,352,179.15,374.63a21,21,0,0,1-10,2.37H169a21,21,0,0,1-10-2.37c-43.58-22.64-88.46-55-120.65-90.73-9.46-10.5-17.26-22.09-22.3-35.43-6-15.77-7.11-32.13-7-48.83.21-61,.09-105.93.08-166.93,0-2.17-.29-4,2.81-4.77,43.83-10.83,88.25-17.39,133.4-18.68C151,9.1,163.28,9,169,9"
              />
              <line
                className="cls-2"
                x1="49.09"
                y1="81.66"
                x2="49.09"
                y2="233.33"
              />
              <line
                className="cls-2"
                x1="89.09"
                y1="113.66"
                x2="89.09"
                y2="201.33"
              />
              <line
                className="cls-2"
                x1="129.09"
                y1="97.66"
                x2="129.09"
                y2="217.33"
              />
              <line
                className="cls-2"
                x1="169.15"
                y1="57.33"
                x2="169.09"
                y2="257.33"
              />
            </g>
          </g>
        </svg>
      </div>
    </div>
  </div>
  );
}

export default BusyOverlay;
